import React from 'react'; // eslint-disable-line no-unused-vars
import styled from 'react-emotion';

const StyledMenu = styled('div')`
  padding: 8px 7px 6px;
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0px;
  margin-top: -6px;
  opacity: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: opacity 0.25s;
  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
  & > * {
    display: inline-block;
  }
  & > * + * {
    padding-right: 10px;
    padding-left: 10px;
    line-height: 22px;
    border-left: 1px solid #ccc;
  }
  & > *:first-child{
    padding-left: 5px;
    padding-right: 10px;
  }
  & > *:last-child{
    padding-right: 5px;
  }
`;

export default StyledMenu;
